import React, { useState } from "react";
import "./pricing.css";
import Navbar from "../Components/navbar";
import ContactUs from "../Components/contactUs";
import PriceCard from "./Components/priceCard";
import PopularPriceCard from "./Components/popularPriceCard";
import TrialBtn from "../Home/Components/trialBtn";

const Pricing = () => {
  const [currency] = useState("PKR"); // default
  const [exchangeRates] = useState({
    PKR: 278,
  });
  // const [rates, setRates] = useState({});
  // const [loading, setLoading] = useState(true);
  // const [error, setError] = useState("");

  // const API_KEY = "d8b6ed5164454d8bafb3bfcabf8dc3cd"; // Replace with your Open Exchange Rates API key

  // useEffect(() => {
  //   const fetchRates = async () => {
  //     setLoading(true);
  //     setError("");

  //     try {
  //       const response = await fetch(
  //         `https://openexchangerates.org/api/latest.json?app_id=${API_KEY}`
  //       );

  //       if (!response.ok) throw new Error("Network response was not ok");

  //       const data = await response.json();
  //       console.log(data);

  //       // data.rates contains all currencies
  //       setRates(data.rates);
  //       setExchangeRates(data.rates);
  //     } catch (err) {
  //       console.error(err);
  //       setError("Failed to fetch exchange rates");
  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  //   fetchRates();
  // }, [API_KEY]);

  const convertPrice = (pricePKR) => {
    if (!exchangeRates || !Object.keys(exchangeRates).length) return pricePKR;

    let converted;

    if (currency === "PKR") {
      converted = pricePKR;
    } else {
      const PKR_per_USD = exchangeRates.PKR; // 1 USD = 280 PKR
      const priceInUSD = pricePKR / PKR_per_USD;

      if (currency === "USD") {
        converted = priceInUSD;
      } else {
        const USD_to_Target = exchangeRates[currency];
        converted = priceInUSD * USD_to_Target;
      }
    }

    let formatted;

    // Format: if more than 1000, convert to K
    if (converted >= 1000) {
      const valueInK = converted / 1000;
      // Remove unnecessary .0
      formatted = Number.isInteger(valueInK)
        ? `${valueInK}K`
        : `${valueInK.toFixed(2)}K`;
    } else {
      formatted = converted.toFixed(2);
    }

    return `${currency} ${formatted}`;
  };

  const card1 = {
    list: [
      "KPI View, Previous Project list",
      "Design Up to 2MW (Configuration only)",
      "Integrated Google Map, Satellite view, Grid view, coordinates",
      "Basic Software and technical support*",
      "Multi roof type selection, roof shape, building details and Multi Roof layout designing",
      "Multi obstacle on multi roof layout design",
      "Single and Multiple Structure placement on Multi roof with custom capacity, Azimuth angle, and row spacing",
      "Multi roof with different structure types",
      "Project summary, BOQ and Basic Report",
    ],
    discount: 5,
    saveMonth: convertPrice(4000),
    saveYearly: convertPrice(54000),
    title: "SMITH Basic",
    price: convertPrice(10000),
    accounts: "1 Admin, 1 Designer Account, 10 Projects",
  };

  const card2 = {
    list: [
      "Everything including in the Basic and Essential",
      "Commercial Modelling service",
      "Monthly Analytics",
      "Customizable Reports & Sales Proposals",
      "Premium Software Support",
      "Dedicated key Account Manager",
      "Customization as per client Requirements",
      "Design Up to 25MW (DC)",
    ],
    discount: 15,
    saveMonth: convertPrice(33000),
    saveYearly: convertPrice(495000),
    title: "SMITH Premium",
    price: convertPrice(55000),
    accounts: "2 Admin, 4 Designer Accounts, Unlimited Projects",
  };

  const card3 = {
    list: [
      "Everything including in the Basic",
      "Design Up to 5MW (DC)",
      "Local weather Data.",
      "Detail Monthly Consumption chart, Yearly consumption.",
      "Up to date component Library and Data base",
      "Multi System type selection e.g. Off-grid, Hybrid and On-grid",
      "Auto generated Detail Inverter One Line string design for single or Multi roof",
      "Bankable energy Yield, financial analysis, Payback and ROI",
      "Detail Single and Multi-roof Project summary, BOQ and Performance report.",
      "Basic Support",
    ],
    discount: 10,
    saveMonth: 125,
    saveYearly: 180,
    title: "SMITH Essential",
    price: convertPrice(25000),
    accounts: "1 Admin, 2 Designer Accounts, 20 Projects",
  };

  return (
    <>
      <Navbar />
      {/* Sub Component 1 */}
      <div className="pricing-header">
        <div className="container">
          <div className="main-text">
            Pricing Plans to accommodate everyone
            <img src="./images/PVX/Line.svg" alt="line" className="underline" />
            <img
              src="./images/PVX/Line.svg"
              alt="line"
              className="underline0"
            />
          </div>
          <div className="sub-text">
            Discover unbeatable value with our transparent pricing. Empowering
            your journey with affordability and clarity
          </div>
        </div>
      </div>
      {/* <div className="currency-selector">
        <label>Select Currency: </label>
        <select value={currency} onChange={(e) => setCurrency(e.target.value)}>
          {exchangeRates &&
            Object.keys(exchangeRates).map((cur) => (
              <option key={cur} value={cur}>
                {cur}
              </option>
            ))}
        </select>
      </div> */}

      {/* Sub Component 2 */}
      <div className="price-cards">
        <div className="card1">
          <img src="./images/PVX/40.svg" className="discount40" alt="40%" />
          <PriceCard {...card1} />
        </div>
        <div className="card2">
          <img src="./images/PVX/60.svg" className="discount60" alt="60%" />
          <PopularPriceCard {...card2} />
        </div>
        <div className="card3">
          <img src="./images/PVX/50.svg" className="discount50" alt="50%" />
          <PriceCard {...card3} />
        </div>
      </div>

      {/* Sub Component 3 */}
      {/* <PVXFrequentlyAsked /> */}

      <ContactUs />
      <TrialBtn />
    </>
  );
};

export default Pricing;
